import { MB_WISHLIST_FEATURE } from './state'
import { NgModule } from '@angular/core'
import { StoreModule } from '@ngrx/store'
import { reducerProvider, reducerToken } from './reducers'
import { EffectsModule } from '@ngrx/effects'
import { effects } from './effects'

@NgModule({
  imports: [
    EffectsModule.forFeature(effects),
    StoreModule.forFeature(MB_WISHLIST_FEATURE, reducerToken),
  ],
  providers: [
    reducerProvider,
  ],
})
export class MbWishlistStoreModule {
}
